import React from 'react';
import TablePagination from '../components/TablePagination';
import { useTablePagination } from '../hooks/useTablePagination';

interface ParticipantRow {
  id: string;
  name: string;
  account: string;
  email: string;
  phone: string;
  role: string;
  meetingNo: string;
  joinTime: string;
}

const ParticipantsList: React.FC = () => {
  const participants: ParticipantRow[] = [
    {
      id: '1',
      name: '聂楷轩',
      account: 'niekaixuan',
      email: 'niekaixuan@360.cn',
      phone: '13165282169',
      role: '用户',
      meetingNo: '663917',
      joinTime: '2026-02-11 17:02:09'
    },
    {
      id: '2',
      name: '齐松妹',
      account: '13436551185',
      email: 'qisongmei-os@360os.com',
      phone: '13436551185',
      role: '用户',
      meetingNo: '517266',
      joinTime: '2026-02-11 16:06:46'
    },
    {
      id: '3',
      name: '张兰兰',
      account: 'z-zhanglanlan',
      email: 'z-zhanglanlan@sharingmail.cn',
      phone: '15527836516',
      role: '用户',
      meetingNo: '370916',
      joinTime: '2026-02-11 15:23:04'
    },
    {
      id: '4',
      name: '张京亮',
      account: '13466566793',
      email: 'v-zhangjingliang@360.cn',
      phone: '13466566793',
      role: '用户',
      meetingNo: '573304',
      joinTime: '2026-02-11 14:36:06'
    },
    {
      id: '5',
      name: '刘文',
      account: 'liuwen3',
      email: 'liuwen3@360.cn',
      phone: '15524458689',
      role: '用户',
      meetingNo: '075965',
      joinTime: '2026-02-11 11:12:20'
    },
    {
      id: '6',
      name: '经销商管理员',
      account: '15717031221@dayu.cn',
      email: 'shyb_info@163.com',
      phone: '15717031221',
      role: '用户',
      meetingNo: '824442',
      joinTime: '2026-02-11 09:37:20'
    },
    {
      id: '7',
      name: '刘舒悦',
      account: '18710256011',
      email: 'v-liushuye1@360.cn',
      phone: '18710256011',
      role: '用户',
      meetingNo: '528435',
      joinTime: '2026-02-10 18:34:15'
    },
    {
      id: '8',
      name: '王彪',
      account: '15733130105',
      email: '',
      phone: '15733130105',
      role: '用户',
      meetingNo: '196524',
      joinTime: '2026-02-10 18:17:17'
    },
    {
      id: '9',
      name: '魏旭红',
      account: '18919183876',
      email: 'v-weixuhong@360.cn',
      phone: '18919183876',
      role: '用户',
      meetingNo: '219865',
      joinTime: '2026-02-10 16:29:44'
    },
    {
      id: '10',
      name: '边琪翼',
      account: '15042659534',
      email: 'v-bianqiao@360.cn',
      phone: '15042659534',
      role: '用户',
      meetingNo: '494159',
      joinTime: '2026-02-10 16:12:29'
    }
  ];
  const {
    total,
    page,
    pageCount,
    pageSize,
    pagedRows,
    setPage,
    setPageSize
  } = useTablePagination(participants);

  return (
    <div className="page-block">
      <div className="breadcrumb">设置 &gt; 用户管理</div>
      <div className="page-card">
        <div className="toolbar">
          <div className="toolbar-left">
            <select className="toolbar-select">
              <option>用户名</option>
              <option>账号</option>
              <option>邮箱</option>
              <option>手机号</option>
            </select>
            <input className="toolbar-input" placeholder="请输入" />
            <button type="button" className="toolbar-icon" aria-label="搜索">
              <span className="icon icon-search" />
            </button>
            <button type="button" className="toolbar-icon" aria-label="刷新">
              <span className="icon icon-refresh" />
            </button>
          </div>
          <button type="button" className="toolbar-export">
            <span className="icon icon-download" />
          </button>
        </div>

        <div className="table-container">
          <table className="compact-table">
            <thead>
              <tr>
                <th>用户名</th>
                <th>账号</th>
                <th>邮箱</th>
                <th>手机号</th>
                <th>角色</th>
                <th>个人会议号</th>
                <th>加入时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.map(participant => (
                <tr key={participant.id}>
                  <td>{participant.name}</td>
                  <td>{participant.account}</td>
                  <td>{participant.email || '—'}</td>
                  <td>{participant.phone}</td>
                  <td>{participant.role}</td>
                  <td>{participant.meetingNo}</td>
                  <td>{participant.joinTime}</td>
                  <td>
                    <button type="button" className="text-link">修改角色</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <TablePagination
          total={total}
          page={page}
          pageCount={pageCount}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
        />
      </div>
    </div>
  );
};

export default ParticipantsList;
